export default (getText: (key: string, category: string) => string) => (key: string) =>
  ({
    content: getText(
      'Here listed are all the follow up history with the patient',
      'Follow_Up_List_Table'
    ),
  }[key])
